import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

import {
  ExternalChannelAccessRequest,
  ExternalChannelAccessResponse,
  ExternalChannelCompleteRegisterRequest,
  LoginRequest,
  LoginResponse,
  MobileLoginRequest,
  MobileLoginResponse
} from '../models/login.model';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private readonly API_URL = '/user';
  private readonly AUTH_URL = '/auth';
  private apiService = inject(ApiService);


  login(credentials: LoginRequest): Observable<LoginResponse> {
    return this.apiService.post<LoginResponse>(
      `${this.API_URL}/login`,
      credentials
    );
  }

  loginMobile(credentials: MobileLoginRequest): Observable<MobileLoginResponse> {
    const headers = new HttpHeaders({
      'x-api-key': 'MKT-40377bcec9e58aade359178c',
      'Content-Type': 'application/json'
    });
    
    return this.apiService.post<MobileLoginResponse>(
      `${this.API_URL}/auth/sue`,
      credentials,
      { headers }
    );
  }

  authPing(code: string): Observable<any> {
    return this.apiService.get(`${this.API_URL}/auth/ping/${code}`);
  }

  externalChannelAccess(payload: ExternalChannelAccessRequest): Observable<ExternalChannelAccessResponse> {
    return this.apiService.post<ExternalChannelAccessResponse>(
      `${this.AUTH_URL}/external-channel-access`,
      payload
    );
  }

  completeExternalChannelRegister(
    payload: ExternalChannelCompleteRegisterRequest
  ): Observable<ExternalChannelAccessResponse> {
    return this.apiService.post<ExternalChannelAccessResponse>(
      `${this.AUTH_URL}/external-channel-access/complete-register`,
      payload
    );
  }
}
